import { useEffect } from "react";

import configEntzy from "components/config/ConfigEntzy";

export const useMediaMaps = (options = {}) => {
  useEffect(() => {
    if (!window.google) {
      const script = document.createElement("script");
      script.type = "text/javascript";
      script.src =
        "https://maps.googleapis.com/maps/api/js?libraries=places,marker&key=" +
        configEntzy.APP_MAPS_PUBLIC_KEY +
        "&callback=Function.prototype&loading=async";
      const headScript = document.getElementsByTagName("script")[0];
      headScript.parentNode.insertBefore(script, headScript);
    }
  }, []);
};

// USAGE
// useMediaMaps(props);
// no return value - activates google maps api for use in components
